import { Injectable } from '@angular/core'
import BaseService from '@ui/Services/BaseService'
import Guest from '@client/Guest'
import { createGuest } from '@client/utils'

@Injectable()
export class GuestService extends BaseService<Guest> {
	public filterable: Guest

	protected endpoint = '/api/guests'

	constructor() {
		super()
		this.filterable = createGuest()
	}

	public find = async (id: number): Promise<Guest> => {
		const json = await this.get({
			url: `${this.endpoint}/${id}`,
		})

		return this.mapToObject(json)
	}

	public createGuest = async (guest: Guest): Promise<Guest> => {
		const json = await this.post(this.endpoint, { guest })

		return this.mapToObject(json)
	}

	public updateGuest = async (guest: Guest): Promise<Guest> => {
		const json = await this.put(`${this.endpoint}/${guest.id}`, { guest })

		return this.mapToObject(json)
	}

	public mapToObject = (json): Guest => {
		return new Guest(
			json.id,
			json.user_id,
			json.name,
			json.status,
			json.dietary_requirements,
			json.created_at,
		)
	}
}
